export default "__VITE_ASSET__CtauV4Sl__"